import { useMemo } from "react";
import { useSearchStore, useUIStore } from "../store";

export const useMenuPlates = (menuData?: any) => {
  const searchTerm = useSearchStore((s) => s.query)?.trim().toLowerCase() ?? "";
  const showSearch = useUIStore((s) => s.showSearch);

  const categoriesToDisplay = useMemo(() => {
    const categories = menuData?.categories ?? [];

    const searchParams = new URLSearchParams(window.location.search);
    const urlProduct = searchParams.get("product");
    const urlTitle = searchParams.get("title") || searchParams.get("name");
    const urlPrice = searchParams.get("price");

    const normalize = (value: unknown) =>
      String(value ?? "").trim().toLowerCase();

    // 1) Primero parcheamos categorías/productos con el override de URL
    const patchedCategories = categories.map((category: any) => ({
      ...category,
      products: (category.products ?? []).map((product: any) => {
        const isTarget =
          urlProduct &&
          normalize(product?.id) === normalize(urlProduct);

        if (!isTarget) return product;

        return {
          ...product,
          title: urlTitle ? decodeURIComponent(urlTitle) : product.title,
          price:
            urlPrice && !Number.isNaN(Number(urlPrice))
              ? Number(urlPrice)
              : product.price,
        };
      }),
    }));

    // 2) Si no hay búsqueda, devolvemos las categorías ya parcheadas
    if (!showSearch || !searchTerm) {
      return patchedCategories;
    }

    // 3) Si hay búsqueda, filtramos SOBRE las categorías ya parcheadas
    return patchedCategories
      .map((category: any) => {
        const filteredProducts = (category.products ?? []).filter((product: any) => {
          const title = product?.title?.toLowerCase?.() ?? "";
          const description = product?.description?.toLowerCase?.() ?? "";
          return title.includes(searchTerm) || description.includes(searchTerm);
        });

        return {
          ...category,
          products: filteredProducts,
        };
      })
      .filter((category: any) => category.products.length > 0);
  }, [menuData, showSearch, searchTerm]);

  return {
    categoriesToDisplay,
    isEmpty: categoriesToDisplay.length === 0,
  };
};